import {collection, component, EntityData, field, identifier, transientField} from "@fedeltapointofsale/data-client";
import {CategoryData, CategoryReferenceData} from "../category/category.data";

export class SizeGroupSellableData extends EntityData<SizeGroupSellableData> {
    @field sellableType: string;
    @identifier sellableId: number;
    @field name: string;
    @component primaryCategory: CategoryReferenceData;
    @field discontinued: boolean;
}

export class SellableSizeData extends EntityData<SellableSizeData> {
    @identifier id: number;
    @field label: string;
}

export class SellableSizeRelationData extends EntityData<SellableSizeRelationData> {
    @identifier id: number;
    @component sellable: SizeGroupSellableData;
    @component sellableSize: SellableSizeData = new SellableSizeData();

    @transientField standardProduct: boolean = false;
}

export class SellableSizeGroupData extends EntityData<SellableSizeGroupData> {
    @identifier id: number;
    @field name: string;
    @collection(SellableSizeData) SellableSizeData: SellableSizeData[];
}

export class SizeGroupRelationData extends EntityData<SizeGroupRelationData> {
    @identifier id: number;
    @field name: string;
    @field externalName: string;
    @field externalSizeName: string;
    @component standardSellable: SizeGroupSellableData;
    @component sellableSizeGroup: SellableSizeGroupData;
    @collection(SellableSizeRelationData) sellableSizeRelations: SellableSizeRelationData[];
}
